import  tim from './tim'

import TRTCCalling from 'trtc-calling-js'
import {timcofig} from "./config"


console.log("-------",timcofig,"kkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkk")

let options = {
  SDKAppID:timcofig.SDKAPPID,  // 接入时需要将0替换为您的云通信应用的 SDKAppID
  tim: tim,
}



console.log(options,7777777)
const trtcCalling = new TRTCCalling(options)

// 4 无日志级别
trtcCalling.setLogLevel(0)

export default trtcCalling



// WEBPACK FOOTER //
// ./src/trtc-calling.js